import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { Paper, Button } from '../Common/Components';

type OpenScannerProps = {
  onOpenScanner: () => void;
};

const useStyles = makeStyles({
  container: {
    display: 'grid',
    gridGap: '32px',
    placeItems: 'center',
    width: '100%',
    maxWidth: 'none',
  },
});

const OpenScanner: React.FC<OpenScannerProps> = ({ onOpenScanner }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.container}>
      <Typography variant="h1">Use the online scanner</Typography>
      <Typography>You need to be a verified merchant to transact on this Data Pass.</Typography>
      <Button className="wide" onClick={onOpenScanner}>
        Open Scanner
      </Button>
    </Paper>
  );
};

export default OpenScanner;
